import { privateApiClient } from './apiClient';

/**
 * Service pour gérer les providers de paiement
 */

/**
 * Récupérer la liste des providers de paiement
 * @param {Object} params - Paramètres de filtrage
 * @param {number} params.pge - Numéro de page
 * @param {string} params.typ - Type de provider ("all" ou type spécifique)
 * @param {string} params.opr - Opération ("PMT" pour paiement, "WDL" pour retrait, "all")
 * @param {number} params.lmt - Limite par page
 * @param {string} params.slug - Slug de recherche
 * @returns {Promise<Object>} La liste des providers
 */
export const fetchProviders = async (params = {}) => {
    try {
        const defaultParams = {
            pge: 1,
            typ: 'all',
            opr: 'PMT', // Par défaut pour les paiements
            lmt: 100,
            slug: '',
            ...params
        };
        console.log('[providerService] Récupération des providers avec params:', defaultParams);
        const response = await privateApiClient.get('/trs/providers', { params: defaultParams });
        console.log('[providerService] Réponse:', {
            total: response.data?.contents?.length || 0,
            sample: response.data?.contents?.[0] || null
        });
        return response.data;
    } catch (error) {
        console.error('[providerService] Erreur lors de la récupération:', error);
        if (error.response) {
            throw new Error(error.response.data?.message || error.response.data?.error || 'Erreur lors de la récupération des providers');
        }
        throw error;
    }
};











